import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import BasicTreeSelect from '../../../components/BasicTreeSelect/BasicTreeSelect';
import { BasicButton } from '../../../assets/common';
import { mappingTalentFinderFilterToExport } from '../../../utils/helper';
import {
  PF_EXPORT_CONFIG_FILTER,
  PF_EXPORT_DEFAULT_SELECT_OPTIONS,
  PF_EXPORT_FILTER_HAS_CHILDREN,
  PF_EXPORT_OPTIONS,
  PF_EXPORT_PARENT_OPTIONS,
  PF_EXPORT_SECTION_NAME,
} from './position-finder-export.constants';

const PositionFinderExportOption = (props) => {
  const { selectedExportOptions, setSelectedExportOptions, handleOnExport, disabled, filter } = props;
  const [selectedOptions, setSelectedOptions] = useState(PF_EXPORT_DEFAULT_SELECT_OPTIONS);

  const handleApply = () => {
    const payloadExport = selectedOptions.filter((i) => !PF_EXPORT_PARENT_OPTIONS.includes(i.value));
    handleOnExport(payloadExport);
    setSelectedOptions([
      ...PF_EXPORT_DEFAULT_SELECT_OPTIONS,
      ...mappingTalentFinderFilterToExport(filter, PF_EXPORT_CONFIG_FILTER, PF_EXPORT_FILTER_HAS_CHILDREN),
    ]);
  };

  useEffect(() => {
    setSelectedOptions([
      ...PF_EXPORT_DEFAULT_SELECT_OPTIONS,
      ...mappingTalentFinderFilterToExport(filter, PF_EXPORT_CONFIG_FILTER, PF_EXPORT_FILTER_HAS_CHILDREN),
    ]);
    setSelectedExportOptions([
      ...PF_EXPORT_DEFAULT_SELECT_OPTIONS,
      ...mappingTalentFinderFilterToExport(filter, PF_EXPORT_CONFIG_FILTER, PF_EXPORT_FILTER_HAS_CHILDREN),
    ]);
  }, [filter]);

  return (
    <BasicTreeSelect
      placement="bottomRight"
      dropdownStyle={{ minWidth: 415, maxWidth: 415 }}
      valueSelectAll={PF_EXPORT_SECTION_NAME.SELECT_ALL}
      onApply={handleApply}
      customApplyText="Export"
      options={PF_EXPORT_OPTIONS}
      selectedOptions={selectedOptions}
      setSelectedOptions={setSelectedOptions}
      prevSelectedOption={selectedExportOptions}
      listHeight={730}
      style={{ height: 30 }}
    >
      <BasicButton mode="teal" disabled={disabled}>
        Export
      </BasicButton>
    </BasicTreeSelect>
  );
};

export default PositionFinderExportOption;

PositionFinderExportOption.propTypes = {
  selectedExportOptions: PropTypes.array,
  setSelectedExportOptions: PropTypes.func,
  handleOnExport: PropTypes.func,
  disabled: PropTypes.bool,
};
